// export const PROGRESS_CSS = `
//   [data-string-progress-dock],
//   [data-stdg-progress] {
//     position: fixed;
//     left: 50%;
//     bottom: 20px;
//     z-index: 10032;
//     width: min(25vw, calc(100vw - 32px));
//     min-width: 360px;
//     max-width: 520px;
//     transform: translate3d(-50%, 16px, 0);
//     opacity: 0;
//     pointer-events: none;
//     transition:
//       opacity 0.22s ease,
//       transform 0.22s ease;
//     box-sizing: border-box;
//     border-radius: 16px;
//     background: rgba(255, 255, 255, 0.98);
//     box-shadow:
//       0 0 0 1px rgba(255, 255, 255, 0.95),
//       0 18px 36px rgba(0, 0, 0, 0.12);
//     padding: 10px 12px 12px;
//     backdrop-filter: blur(18px);
//   }

//   [data-stdg-progress][data-open="true"] {
//     opacity: 1;
//     transform: translate3d(-50%, 0, 0);
//     pointer-events: auto;
//   }

//   [data-stdg-panel-header] {
//     display: grid;
//     grid-template-columns: minmax(0, 1fr) auto 28px;
//     align-items: center;
//     column-gap: 8px;
//     margin-bottom: 8px;
//   }

//   [data-stdg-panel-header] > span:first-child,
//   [data-string-progress-dock-title] {
//     min-width: 0;
//     color: #111111;
//     font-family: var(--string-dev-panel-font-family);
//     font-size: 13px;
//     font-weight: 700;
//     line-height: 1.2;
//     text-align: left;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//   }

//   [data-stdg-button-left],
//   [data-string-progress-dock-play-group] {
//     display: flex;
//     align-items: center;
//     gap: 2px;
//     justify-self: center;
//     order: -1;
//   }

//   [data-stdg-button][data-string-progress-dock-play-forward],
//   [data-stdg-button][data-string-progress-dock-play-backward],
//   [data-stdg-button][data-string-progress-dock-close],
//   [data-string-progress-dock-play-forward],
//   [data-string-progress-dock-play-backward],
//   [data-string-progress-dock-close] {
//     width: 28px;
//     height: 28px;
//     padding: 0;
//     border: 0;
//     background: transparent;
//     color: #111111;
//     display: inline-flex;
//     align-items: center;
//     justify-content: center;
//     cursor: pointer;
//     border-radius: 6px;
//     transition: color 0.15s ease, background 0.15s ease;
//   }

//   [data-stdg-button][data-string-progress-dock-play-forward]:hover,
//   [data-stdg-button][data-string-progress-dock-play-backward]:hover,
//   [data-stdg-button][data-string-progress-dock-close]:hover,
//   [data-string-progress-dock-play-forward]:hover,
//   [data-string-progress-dock-play-backward]:hover,
//   [data-string-progress-dock-close]:hover,
//   [data-stdg-button][data-string-progress-dock-play-forward]:focus-visible,
//   [data-stdg-button][data-string-progress-dock-play-backward]:focus-visible,
//   [data-stdg-button][data-string-progress-dock-close]:focus-visible,
//   [data-string-progress-dock-play-forward]:focus-visible,
//   [data-string-progress-dock-play-backward]:focus-visible,
//   [data-string-progress-dock-close]:focus-visible {
//     background: rgba(17, 17, 17, 0.06);
//     outline: none;
//   }

//   [data-stdg-button][data-string-progress-dock-play-forward] svg,
//   [data-stdg-button][data-string-progress-dock-play-backward] svg,
//   [data-stdg-button][data-string-progress-dock-close] svg,
//   [data-string-progress-dock-play-forward] svg,
//   [data-string-progress-dock-play-backward] svg,
//   [data-string-progress-dock-close] svg {
//     width: 16px;
//     height: 16px;
//   }

//   [data-stdg-button][data-string-progress-dock-play-forward][data-active="true"],
//   [data-stdg-button][data-string-progress-dock-play-backward][data-active="true"],
//   [data-string-progress-dock-play-forward][data-active="true"],
//   [data-string-progress-dock-play-backward][data-active="true"] {
//     color: rgba(17, 17, 17, 0.35);
//   }

//   [data-stdg-button-right],
//   [data-string-progress-dock-close] {
//     justify-self: end;
//   }

//   [data-stdg-panel-content] {
//     display: block;
//   }

//   [data-stdg-panel-field-slider-row] {
//     display: grid;
//     grid-template-columns: minmax(0, 1fr) 80px;
//     gap: 8px;
//     align-items: stretch;
//   }

//   [data-stdg-panel-field][data-string-progress-field],
//   [data-string-progress-field] {
//     position: relative;
//     min-width: 0;
//     min-height: 40px;
//     display: flex;
//     align-items: center;
//     padding: 0;
//     border-radius: 14px;
//     background: #efefef;
//     box-sizing: border-box;
//     overflow: hidden;
//   }

//   [data-stdg-panel-field-slider] > label {
//     flex: 0 0 auto;
//     padding-left: 14px;
//     padding-right: 12px;
//     color: rgba(17, 17, 17, 0.45);
//     font-family: var(--string-dev-panel-font-family);
//     font-size: 12px;
//     font-weight: 500;
//     line-height: 1;
//     user-select: none;
//   }

//   [data-stdg-input][data-string-progress-slider],
//   [data-string-progress-slider] {
//     flex: 1 1 auto;
//     width: 100%;
//     height: 40px;
//     display: block;
//     margin: 0;
//     appearance: none;
//     -webkit-appearance: none;
//     background: transparent;
//     cursor: pointer;
//   }

//   [data-stdg-input][data-string-progress-slider]:focus-visible,
//   [data-string-progress-slider]:focus-visible {
//     outline: none;
//   }

//   [data-stdg-input][data-string-progress-slider]::-webkit-slider-runnable-track,
//   [data-string-progress-slider]::-webkit-slider-runnable-track {
//     height: 40px;
//     border-radius: 0;
//     background:
//       linear-gradient(
//         90deg,
//         rgba(17, 17, 17, 0.12) 0%,
//         rgba(17, 17, 17, 0.12) var(--string-progress-slider-fill),
//         transparent var(--string-progress-slider-fill),
//         transparent 100%
//       );
//   }

//   [data-stdg-input][data-string-progress-slider]::-webkit-slider-thumb,
//   [data-string-progress-slider]::-webkit-slider-thumb {
//     -webkit-appearance: none;
//     width: 2px;
//     height: 46px;
//     border: 0;
//     border-radius: 999px;
//     background: #111111;
//     margin-top: -4px;
//     box-shadow: none;
//   }

//   [data-stdg-input][data-string-progress-slider]::-moz-range-track,
//   [data-string-progress-slider]::-moz-range-track {
//     height: 40px;
//     border: 0;
//     border-radius: 0;
//     background: transparent;
//   }

//   [data-stdg-input][data-string-progress-slider]::-moz-range-progress,
//   [data-string-progress-slider]::-moz-range-progress {
//     height: 40px;
//     background: rgba(17, 17, 17, 0.12);
//   }

//   [data-stdg-input][data-string-progress-slider]::-moz-range-thumb,
//   [data-string-progress-slider]::-moz-range-thumb {
//     width: 4px;
//     height: 52px;
//     border: 0;
//     border-radius: 999px;
//     background: #111111;
//     box-shadow: none;
//   }

//   [data-stdg-panel-field][data-string-progress-value-card],
//   [data-string-progress-value-card] {
//     min-height: 40px;
//     display: grid;
//     grid-template-columns: minmax(0, 1fr) auto;
//     align-items: center;
//     padding: 0 14px;
//     border-radius: 14px;
//     background: #efefef;
//     box-sizing: border-box;
//   }

//   [data-stdg-input][data-string-progress-value-number],
//   [data-string-progress-value-number] {
//     width: 100%;
//     min-width: 0;
//     border: 0;
//     background: transparent;
//     color: #111111;
//     font-family: var(--string-dev-panel-font-family);
//     font-size: 13px;
//     font-weight: 600;
//     line-height: 1;
//     text-align: center;
//     outline: none;
//     padding: 0;
//     -moz-appearance: textfield;
//   }

//   [data-stdg-input][data-string-progress-value-number]::-webkit-inner-spin-button,
//   [data-stdg-input][data-string-progress-value-number]::-webkit-outer-spin-button,
//   [data-string-progress-value-number]::-webkit-inner-spin-button,
//   [data-string-progress-value-number]::-webkit-outer-spin-button {
//     -webkit-appearance: none;
//   }

//   [data-stdg-field-input-disable][data-string-progress-value-unit],
//   [data-string-progress-value-unit] {
//     display: inline-flex;
//     align-items: center;
//     padding-left: 12px;
//     margin-left: 12px;
//     border-left: 1px solid rgba(17, 17, 17, 0.14);
//     color: rgba(17, 17, 17, 0.45);
//     font-family: var(--string-dev-panel-font-family);
//     font-size: 13px;
//     font-weight: 500;
//     line-height: 1;
//   }

//   @media (max-width: 720px) {
//     [data-string-progress-dock],
//     [data-stdg-progress] {
//       width: calc(100vw - 20px);
//       min-width: 0;
//       max-width: none;
//       bottom: 10px;
//       padding: 12px 10px 10px;
//     }

//     [data-stdg-panel-header] {
//       grid-template-columns: minmax(0, 1fr) auto 28px;
//       margin-bottom: 10px;
//     }

//     [data-stdg-panel-field-slider-row] {
//       grid-template-columns: 1fr;
//     }

//     [data-stdg-panel-field][data-string-progress-field],
//     [data-string-progress-field] {
//       min-height: 48px;
//     }

//     [data-stdg-panel-field-slider] > label {
//       font-size: 15px;
//     }

//     [data-stdg-input][data-string-progress-slider]::-webkit-slider-runnable-track,
//     [data-stdg-input][data-string-progress-slider]::-webkit-slider-thumb,
//     [data-stdg-input][data-string-progress-slider]::-moz-range-track,
//     [data-stdg-input][data-string-progress-slider]::-moz-range-progress,
//     [data-stdg-input][data-string-progress-slider]::-moz-range-thumb,
//     [data-string-progress-slider]::-webkit-slider-runnable-track,
//     [data-string-progress-slider]::-webkit-slider-thumb,
//     [data-string-progress-slider]::-moz-range-track,
//     [data-string-progress-slider]::-moz-range-progress,
//     [data-string-progress-slider]::-moz-range-thumb {
//       height: 48px;
//     }

//     [data-stdg-panel-field][data-string-progress-value-card],
//     [data-string-progress-value-card] {
//       min-height: 48px;
//       padding: 0 14px;
//     }
//   }
// `;
export const PROGRESS_CSS = "";
